const translations = {
    English: {
        title: "Loop Calculator", loop: "Loop", totalDevices: "Total devices in loop:", consumption: "Total consumption:",
        crossSection: "Cross-section:", cableLength: "Length of cable:", batteryCapacity: "Capacity of batteries:",
        additionalConsumption: "Additional sounders and other devices consumption:", workHours: "Work hours on battery:",
        save: "Save", load: "Load", new: "New", print: "Print PDF", excel: "Export Excel",
        infoTooltip: "Total devices must not exceed 250. Total consumption must not exceed 700 mA.",
        pdfDevice: "Device", pdfQuantity: "Quantity", pdfCurrent: "Current (mA)",
        pdfReportTitle: "Loop Device Report",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Capacity of batteries:",
        pdfAdditionalConsumption: "Additional sounders and other devices consumption:",
        pdfWorkHours: "Work hours on battery",
        excelExportTime: "Export Date & Time:",
        excelPanelType: "Panel Type:",
        excelLoopNumber: "Loop Number:",
        excelDeviceName: "Device Name",
        excelQuantity: "Quantity",
        excelConsumption: "Consumption (mA)",
        excelTotalDevicesLoop: "Total Devices (Loop):",
        excelTotalConsumptionLoop: "Total Consumption (Loop):",
        excelLineResistance: "Calculated Line Resistance:",
        excelCableResistance: "Calculated Cable Resistance:",
        excelCableLength: "Calculated Cable Length (based on selected cross-section):",
        excelInputLength: "Input Cable Length:",
        excelSelectedCross: "Selected Cable Cross-Section:",
        excelRequiredCross: "Required Cable Cross-Section (for input length):",
        excelBatteryCalcTitle: "--- Global Battery Life Calculation (All Loops) ---",
        excelSelectedBattery: "Capacity of batteries:",
        excelTotalIdleCons: "Total Idle Consumption (All Loops):",
        excelTotalActiveCons: "Total Active Consumption (All Loops):",
        excelPassiveLife: "Estimated Passive Battery Life (All Loops):",
        inputCrossSectionTitle: "Input Cross-section:",
        inputCableLengthTitle: "Input Cable length:",
        batteryAutonomyTitle: "Battery autonomy:",
        optSmokeDetector: "Addressable Optical smoke detector",
        heatDetector: "Addressable Heat detector",
        optSmokeHeatDetector: "Addressable Optical smoke and Heat detector",
        manualCallPoint: "Addressable Manual Call Point device",
        siren: "Addressable Sounder",
        module: "Addressable Module for conventional zone",
        inOutDevice: "Addressable Input/Output device",
        showAdditionalSettings: "Show Additional Settings", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Hide Additional Settings", // NEW TRANSLATION KEY
        askShareExportedFile: "File exported successfully. Do you want to share it now?",
        maxIzulatorWarning: "MAX. NUMBER OF ISOLATOR DEVICES IS 100",
    },
    Български: {
        title: "Калкулатор", loop: "Контур", totalDevices: "Брой устройства:", consumption: "Консумация (ток):",
        crossSection: "Сечение:", cableLength: "Дължина на кабел:", batteryCapacity: "Капацитет на акумулаторите:",
        additionalConsumption: "Консумация на допълнителни сирени и устройства:", workHours: "Часове на работа от акумулатор:",
        save: "Запази", load: "Зареди", new: "Нов", print: "Печат PDF", excel: "Експорт Excel",
        infoTooltip: "Устройствата не трябва да надвишават 250. Консумацията не трябва да надвишава 700 mA.",
        pdfDevice: "Устройство", pdfQuantity: "Количество", pdfCurrent: "Ток (mA)",
        pdfReportTitle: "Отчет за устройствата по контури:",
        pdfCableLengthM: "м",
        pdfCrossSectionMM: "мм2",
        pdfBatteryCapacity: "Капацитет на акумулаторите:",
        pdfAdditionalConsumption: "Консумация на допълнителни сирени и устройства:",
        pdfWorkHours: "Часове на работа от акумулатор:",
        excelExportTime: "Дата и час на експорта:",
        excelPanelType: "Тип централа:",
        excelLoopNumber: "Контур №:",
        excelDeviceName: "Име на устройство",
        excelQuantity: "Брой",
        excelConsumption: "Консумация (mA)",
        excelTotalDevicesLoop: "Общо устройства (контур):",
        excelTotalConsumptionLoop: "Обща консумация (контур):",
        excelLineResistance: "Съпротивление на линия:",
        excelCableResistance: "Съпротивление на кабел:",
        excelCableLength: "Изчислена дължина на кабел:",
        excelInputLength: "Въведена дължина на кабел:",
        excelSelectedCross: "Избрано сечение:",
        excelRequiredCross: "Необходимо сечение:",
        excelBatteryCalcTitle: "--- Глобално изчисление на батерия ---",
        excelSelectedBattery: "Капацитет на акумулаторите:",
        excelTotalIdleCons: "Обща консумация в дежурен режим (всички контури):",
        excelTotalActiveCons: "Обща активна консумация (всички контури):",
        excelPassiveLife: "Изчислен живот в дежурен режим:",
        inputCrossSectionTitle: "Въведи Сечение:",
        inputCableLengthTitle: "Въведи Дължина на Кабел:",
        batteryAutonomyTitle: "Автономност с акумулатори:",
        optSmokeDetector: "Адресна оптично димен пожароизвестител",
        heatDetector: "Адресен топлинен пожароизвестител",
        optSmokeHeatDetector: "Адресен комбиниран оптично димен и топлинен пожароизвестител",
        manualCallPoint: "Адресен ръчен пожароизвестител",
        siren: "Адресна сирена",
        module: "Адресен адаптер за конвенционална линия",
        inOutDevice: "Адресно входно-изходно устройство",
        showAdditionalSettings: "Покажи Допълнителни Настройки", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Скрий Допълнителни Настройки", // NEW TRANSLATION KEY
        askShareExportedFile: "Файлът беше експортиран успешно. Искате ли да го споделите сега?",
        maxIzulatorWarning: "МАКС. БРОЙ ИЗОЛАТОРНИ У-ВА Е 100!",
    },
    Türkçe: {
        title: "Döngü Hesaplayıcı", loop: "Döngü", totalDevices: "Döngüdeki toplam cihaz sayısı:", consumption: "Toplam tüketim:",
        crossSection: "Kesit:", cableLength: "Kablo uzunluğu:", batteryCapacity: "Pil kapasitesi:",
        additionalConsumption: "Ek sirenler ve diğer cihazların tüketimi:", workHours: "Çalışma saatleri:",
        save: "Kaydet", load: "Yükle", new: "Yeni", print: "PDF Yazdır", excel: "Excel'e Aktar",
        infoTooltip: "Toplam cihaz sayısı 250'yi geçmemelidir. Toplam tüketim 700 mA'ı geçmemelidir.",
        pdfDevice: "Cihaz", pdfQuantity: "Miktar", pdfCurrent: "Akım (mA)",
        pdfReportTitle: "Döngü Cihaz Raporu",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Pil kapasitesi:",
        pdfAdditionalConsumption: "Ek sirenler ve diğer cihazların tüketimi:",
        pdfWorkHours: "Çalışma saatleri:",
        excelExportTime: "Dışa Aktarma Tarihi ve Saati:",
        excelPanelType: "Panel Türü:",
        excelLoopNumber: "Döngü Numarası:",
        excelDeviceName: "Cihaz Adı",
        excelQuantity: "Miktar",
        excelConsumption: "Tüketim (mA)",
        excelTotalDevicesLoop: "Toplam Cihaz (Döngü):",
        excelTotalConsumptionLoop: "Toplam Tüketim (Döngü):",
        excelLineResistance: "Hesaplanan Hat Direnci:",
        excelCableResistance: "Hesaplanan Kablo Direnci:",
        excelCableLength: "Hesaplanan Kablo Uzunluğu (seçilen kesite göre):",
        excelInputLength: "Girilen Kablo Uzunluğu:",
        excelSelectedCross: "Seçilen Kablo Kesiti:",
        excelRequiredCross: "Gerekli Kablo Kesiti (girilen uzunluk için):",
        excelBatteryCalcTitle: "--- Genel Pil Ömrü Hesaplaması (Tüm Döngüler) ---",
        excelSelectedBattery: "Pil kapasitesi:",
        excelTotalIdleCons: "Toplam Bekleme Tüketimi (Tüm Döngüler):",
        excelTotalActiveCons: "Toplam Aktif Tüketim (Tüm Döngüler):",
        excelPassiveLife: "Tahmini Pasif Pil Ömrü (Tüm Döngüler):",
        inputCrossSectionTitle: "Kesit Girin:",
        inputCableLengthTitle: "Kablo Uzunluğu Girin:",
        batteryAutonomyTitle: "Pil özerkliği:",
        optSmokeDetector: "Adreslenebilir Optik duman dedektörü",
        heatDetector: "Adreslenebilir Isı dedektörü",
        optSmokeHeatDetector: "Adreslenebilir Optik duman ve Isı dedektörü",
        manualCallPoint: "Adreslenebilir Manuel Çağrı Noktası cihazı",
        siren: "Adreslenebilir Siren",
        module: "Konvansiyonel bölge için adreslenebilir modül",
        inOutDevice: "Adreslenebilir Giriş/Çıkış cihazı",
        showAdditionalSettings: "Ek Ayarları Göster", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Ek Ayarları Gizle", // NEW TRANSLATION KEY
        askShareExportedFile: "Dosya başarıyla dışa aktarıldı. Şimdi paylaşmak ister misiniz?",
        maxIzulatorWarning: "MAKS. İZOLATÖR CİHAZ SAYISI 100'DÜR!",
    },
    Français: {
        title: "Calculateur de Boucle", loop: "Boucle", totalDevices: "Nombre total d'appareils dans la boucle:", consumption: "Consommation totale:",
        crossSection: "Section transversale:", cableLength: "Longueur du câble:", batteryCapacity: "Capacité des batteries:",
        additionalConsumption: "Consommation supplémentaire des sirènes et autres appareils:", workHours: "Heures de travail:",
        save: "Enregistrer", load: "Charger", new: "Nouveau", print: "Imprimer PDF", excel: "Exporter Excel",
        infoTooltip: "Le nombre total d'appareils ne doit pas dépasser 250. La consommation totale ne doit pas dépasser 700 mA.",
        pdfDevice: "Appareil", pdfQuantity: "Quantité", pdfCurrent: "Courant (mA)",
        pdfReportTitle: "Rapport d'appareils de boucle",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Capacité des batteries:",
        pdfAdditionalConsumption: "Consommation supplémentaire des sirènes et autres appareils:",
        pdfWorkHours: "Heures de travail:",
        excelExportTime: "Date et heure d'exportation:",
        excelPanelType: "Type de panneau:",
        excelLoopNumber: "Numéro de boucle:",
        excelDeviceName: "Nom de l'appareil",
        excelQuantity: "Quantité",
        excelConsumption: "Consommation (mA)",
        excelTotalDevicesLoop: "Total des appareils (Boucle):",
        excelTotalConsumptionLoop: "Consommation totale (Boucle):",
        excelLineResistance: "Résistance de ligne calculée:",
        excelCableResistance: "Résistance du câble calculée:",
        excelCableLength: "Longueur de câble calculée (basée sur la section transversale sélectionnée):",
        excelInputLength: "Longueur de câble saisie:",
        excelSelectedCross: "Section transversale du câble sélectionnée:",
        excelRequiredCross: "Section transversale requise (pour la longueur saisie):",
        excelBatteryCalcTitle: "--- Calcul global de la durée de vie de la batterie (Toutes les boucles) ---",
        excelSelectedBattery: "Capacité des batteries:",
        excelTotalIdleCons: "Consommation totale en veille (Toutes les boucles):",
        excelTotalActiveCons: "Consommation active totale (Toutes les boucles):",
        excelPassiveLife: "Durée de vie estimée de la batterie en mode passif (Toutes les boucles):",
        inputCrossSectionTitle: "Entrez la section transversale:",
        inputCableLengthTitle: "Entrez la longueur du câble:",
        batteryAutonomyTitle: "Autonomie de la batterie:",
        optSmokeDetector: "Détecteur de fumée optique adressable",
        heatDetector: "Détecteur de chaleur adressable",
        optSmokeHeatDetector: "Détecteur de fumée optique et de chaleur adressable",
        manualCallPoint: "Dispositif de point d'appel manuel adressable",
        siren: "Sirène adressable",
        module: "Module adressable pour zone conventionnelle",
        inOutDevice: "Dispositif d'entrée/sortie adressable",
        showAdditionalSettings: "Afficher les Paramètres Supplémentaires", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Masquer les Paramètres Supplémentaires", // NEW TRANSLATION KEY
        askShareExportedFile: "Fichier exporté avec succès. Voulez-vous le partager maintenant ?",
        maxIzulatorWarning: "NBRE MAX. D'APPAREILS ISOLATEURS : 100 !",
    },
    Latviešu: {
        title: "Cikla Kalkulators", loop: "Cikls", totalDevices: "Ierīču skaits ciklā:", consumption: "Kopējais patēriņš:",
        crossSection: "Šķērsgriezums:", cableLength: "Kabeļa garums:", batteryCapacity: "Akumulatoru kapacitāte:",
        additionalConsumption: "Papildu skaņas signālu un citu ierīču patēriņš:", workHours: "Darba stundas:",
        save: "Saglabāt", load: "Ielādēt", new: "Jauns", print: "Drukāt PDF", excel: "Eksportēt Excel",
        infoTooltip: "Kopējais ierīču skaits nedrīkst pārsniegt 250. Kopējais patēriņš nedrīkst pārsniegt 700 mA.",
        pdfDevice: "Ierīce", pdfQuantity: "Daudzums", pdfCurrent: "Strāva (mA)",
        pdfReportTitle: "Cikla Ierīču Atskaite",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Akumulatoru kapacitāte:",
        pdfAdditionalConsumption: "Papildu skaņas signālu un citu ierīču patēriņš:",
        pdfWorkHours: "Darba stundas:",
        excelExportTime: "Eksporta datums un laiks:",
        excelPanelType: "Paneļa tips:",
        excelLoopNumber: "Cikla numurs:",
        excelDeviceName: "Ierīces nosaukums",
        excelQuantity: "Daudzums",
        excelConsumption: "Patēriņš (mA)",
        excelTotalDevicesLoop: "Kopējais ierīču skaits (Cikls):",
        excelTotalConsumptionLoop: "Kopējais patēriņš (Cikls):",
        excelLineResistance: "Aprēķinātā līnijas pretestība:",
        excelCableResistance: "Aprēķinātā kabeļa pretestība:",
        excelCableLength: "Aprēķinātais kabeļa garums (pamatojoties uz izvēlēto šķērsgriezumu):",
        excelInputLength: "Ievadītais kabeļa garums:",
        excelSelectedCross: "Izvēlētais kabeļa šķērsgriezums:",
        excelRequiredCross: "Nepieciešamais kabeļa šķērsgriezums (ievadītajam garumam):",
        excelBatteryCalcTitle: "--- Globālā akumulatora darbības laika aprēķins (Visi cikli) ---",
        excelSelectedBattery: "Akumulatoru kapacitāte:",
        excelTotalIdleCons: "Kopējais dīkstāves patēriņš (Visi cikli):",
        excelTotalActiveCons: "Kopējais aktīvais patēriņš (Visi cikli):",
        excelPassiveLife: "Paredzamais akumulatora darbības laiks pasīvajā režīmā (Visi cikli):",
        inputCrossSectionTitle: "Ievadiet šķērsgriezumu:",
        inputCableLengthTitle: "Ievadiet kabeļa garumu:",
        batteryAutonomyTitle: "Akumulatora autonomija:",
        optSmokeDetector: "Adresējams optiskais dūmu detektors",
        heatDetector: "Adresējams siltuma detektors",
        optSmokeHeatDetector: "Adresējams optiskais dūmu un siltuma detektors",
        manualCallPoint: "Adresējama rokas izsaukuma ierīce",
        siren: "Adresējama sirēna",
        module: "Adresējams modulis parastajai zonai",
        inOutDevice: "Adresējama ievades/izvades ierīce",
        showAdditionalSettings: "Rādīt Papildu Iestatījumus", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Slēpt Papildu Iestatījumus", // NEW TRANSLATION KEY
        askShareExportedFile: "Fails veiksmīgi eksportēts. Vai vēlaties to tagad kopīgot?",
        maxIzulatorWarning: "MAKS. IZOLATORU IERĪČU SKAITS IR 100!",
    },
    Română: {
        title: "Calculator Buclă", loop: "Buclă", totalDevices: "Dispozitive totale în buclă:", consumption: "Consum total:",
        crossSection: "Secțiune transversală:", cableLength: "Lungime cablu:", batteryCapacity: "Capacitate baterii:",
        additionalConsumption: "Consum suplimentar sirene și alte dispozitive:", workHours: "Ore de funcționare:",
        save: "Salvează", load: "Încarcă", new: "Nou", print: "Tipărește PDF", excel: "Exportă Excel",
        infoTooltip: "Numărul total de dispozitive nu trebuie să depășească 250. Consumul total nu trebuie să depășească 700 mA.",
        pdfDevice: "Dispozitiv", pdfQuantity: "Cantitate", pdfCurrent: "Curent (mA)",
        pdfReportTitle: "Raport Dispozitive Buclă",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Capacitate baterii:",
        pdfAdditionalConsumption: "Consum suplimentar sirene și alte dispozitive:",
        pdfWorkHours: "Ore de funcționare:",
        excelExportTime: "Data și ora exportului:",
        excelPanelType: "Tip panou:",
        excelLoopNumber: "Număr buclă:",
        excelDeviceName: "Nume dispozitiv",
        excelQuantity: "Cantitate",
        excelConsumption: "Consum (mA)",
        excelTotalDevicesLoop: "Total dispozitive (Buclă):",
        excelTotalConsumptionLoop: "Consum total (Buclă):",
        excelLineResistance: "Rezistență linie calculată:",
        excelCableResistance: "Rezistență cablu calculată:",
        excelCableLength: "Lungime cablu calculată (pe baza secțiunii transversale selectate):",
        excelInputLength: "Lungime cablu introdusă:",
        excelSelectedCross: "Secțiune transversală cablu selectată:",
        excelRequiredCross: "Secțiune transversală necesară (pentru lungimea introdusă):",
        excelBatteryCalcTitle: "--- Calcul global durată baterie (Toate buclele) ---",
        excelSelectedBattery: "Capacitate baterii:",
        excelTotalIdleCons: "Consum total în standby (Toate buclele):",
        excelTotalActiveCons: "Consum activ total (Toate buclele):",
        excelPassiveLife: "Durată estimată baterie în mod pasiv (Toate buclele):",
        inputCrossSectionTitle: "Introduceți secțiunea transversală:",
        inputCableLengthTitle: "Introduceți lungimea cablului:",
        batteryAutonomyTitle: "Autonomie baterie:",
        optSmokeDetector: "Detector de fum optic adresabil",
        heatDetector: "Detector de căldură adresabil",
        optSmokeHeatDetector: "Detector de fum optic și căldură adresabil",
        manualCallPoint: "Dispozitiv manual de apel adresabil",
        siren: "Sirenă adresabilă",
        module: "Modul adresabil pentru zonă convențională",
        inOutDevice: "Dispozitiv intrare/ieșire adresabil",
        showAdditionalSettings: "Afișează Setări Suplimentare", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Ascunde Setări Suplimentare", // NEW TRANSLATION KEY
        askShareExportedFile: "Fișierul a fost exportat cu succes. Doriți să îl partajați acum?",
        maxIzulatorWarning: "NR. MAX. DE DISPOZITIVE IZOLATOARE ESTE 100!",
    },
    Српски: {
        title: "Калкулатор петље", loop: "Петља", totalDevices: "Укупно уређаја у петљи:", consumption: "Укупна потрошња:",
        crossSection: "Попречни пресек:", cableLength: "Дужина кабла:", batteryCapacity: "Капацитет батерија:",
        additionalConsumption: "Додатна потрошња сирена и других уређаја:", workHours: "Радни сати:",
        save: "Сачувај", load: "Учитај", new: "Нови", print: "Штампај PDF", excel: "Извези Excel",
        infoTooltip: "Укупан број уређаја не сме бити већи од 250. Укупна потрошња не сме бити већа од 700 mA.",
        pdfDevice: "Уређај", pdfQuantity: "Количина", pdfCurrent: "Струја (mA)",
        pdfReportTitle: "Извештај о уређајима у петљи",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Капацитет батерија:",
        pdfAdditionalConsumption: "Додатна потрошња сирена и других уређаја:",
        pdfWorkHours: "Радни сати:",
        excelExportTime: "Време извоза:",
        excelPanelType: "Тип панела:",
        excelLoopNumber: "Број петље:",
        excelDeviceName: "Назив уређаја",
        excelQuantity: "Количина",
        excelConsumption: "Потрошња (mA)",
        excelTotalDevicesLoop: "Укупно уређаја (Петља):",
        excelTotalConsumptionLoop: "Укупна потрошња (Петља):",
        excelLineResistance: "Израчунати отпор линије:",
        excelCableResistance: "Израчунати отпор кабла:",
        excelCableLength: "Израчуната дужина кабла (на основу изабраног пресека):",
        excelInputLength: "Унета дужина кабла:",
        excelSelectedCross: "Изабрани пресек кабла:",
        excelRequiredCross: "Потребан пресек кабла (за унету дужину):",
        excelBatteryCalcTitle: "--- Глобални прорачун трајања батерија (Све петље) ---",
        excelSelectedBattery: "Капацитет батерија:",
        excelTotalIdleCons: "Укупна потрошња у мировању (Све петље):",
        excelTotalActiveCons: "Укупна активна потрошња (Све петље):",
        excelPassiveLife: "Процењено трајање батерија у пасивном режиму (Све петље):",
        inputCrossSectionTitle: "Унесите пресек:",
        inputCableLengthTitle: "Унесите дужину кабла:",
        batteryAutonomyTitle: "Аутономија батерија:",
        optSmokeDetector: "Адресибилни оптички детектор дима",
        heatDetector: "Адресибилни детектор топлоте",
        optSmokeHeatDetector: "Адресибилни оптички детектор дима и топлоте",
        manualCallPoint: "Адресибилни ручни позивни уређај",
        siren: "Адресибилна сирена",
        module: "Адресибилни модул за конвенционалну зону",
        inOutDevice: "Адресибилни улазно/излазни уређај",
        showAdditionalSettings: "Прикажи Додатна Подешавања", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Сакриј Додатна Подешавања", // NEW TRANSLATION KEY
        askShareExportedFile: "Фајл је успешно извезен. Желите ли да га сада делите?",
        maxIzulatorWarning: "МАКС. БРОЈ ИЗОЛАТОРСКИХ УРЕЂАЈА ЈЕ 100!",
    },
    Русский: {
        title: "Калькулятор шлейфа", loop: "Шлейф", totalDevices: "Всего устройств в шлейфе:", consumption: "Общее потребление:",
        crossSection: "Сечение:", cableLength: "Длина кабеля:", batteryCapacity: "Емкость аккумуляторов:",
        additionalConsumption: "Дополнительное потребление сирен и других устройств:", workHours: "Часы работы:",
        save: "Сохранить", load: "Загрузить", new: "Новый", print: "Печать PDF", excel: "Экспорт Excel",
        infoTooltip: "Общее количество устройств не должно превышать 250. Общее потребление не должно превышать 700 мА.",
        pdfDevice: "Устройство", pdfQuantity: "Количество", pdfCurrent: "Ток (мА)",
        pdfReportTitle: "Отчет по устройствам шлейфа",
        pdfCableLengthM: "м",
        pdfCrossSectionMM: "мм2",
        pdfBatteryCapacity: "Емкость аккумуляторов:",
        pdfAdditionalConsumption: "Дополнительное потребление сирен и других устройств:",
        pdfWorkHours: "Часы работы:",
        excelExportTime: "Дата и время экспорта:",
        excelPanelType: "Тип панели:",
        excelLoopNumber: "Номер шлейфа:",
        excelDeviceName: "Название устройства",
        excelQuantity: "Количество",
        excelConsumption: "Потребление (мА)",
        excelTotalDevicesLoop: "Всего устройств (Шлейф):",
        excelTotalConsumptionLoop: "Общее потребление (Шлейф):",
        excelLineResistance: "Рассчитанное сопротивление линии:",
        excelCableResistance: "Рассчитанное сопротивление кабеля:",
        excelCableLength: "Рассчитанная длина кабеля (на основе выбранного сечения):",
        excelInputLength: "Введенная длина кабеля:",
        excelSelectedCross: "Выбранное сечение кабеля:",
        excelRequiredCross: "Необходимое сечение кабеля (для введенной длины):",
        excelBatteryCalcTitle: "--- Глобальный расчет времени работы батарей (Все шлейфы) ---",
        excelSelectedBattery: "Емкость аккумуляторов:",
        excelTotalIdleCons: "Общее потребление в режиме ожидания (Все шлейфы):",
        excelTotalActiveCons: "Общее активное потребление (Все шлейфы):",
        excelPassiveLife: "Расчетное время работы в пассивном режиме (Все шлейфы):",
        inputCrossSectionTitle: "Введите сечение:",
        inputCableLengthTitle: "Введите длину кабеля:",
        batteryAutonomyTitle: "Автономность батарей:",
        optSmokeDetector: "Адресуемый оптический дымовой извещатель",
        heatDetector: "Адресуемый тепловой извещатель",
        optSmokeHeatDetector: "Адресуемый оптический дымовой и тепловой извещатель",
        manualCallPoint: "Адресуемое ручное устройство вызова",
        siren: "Адресуемая сирена",
        module: "Адресуемый модуль для обычной зоны",
        inOutDevice: "Адресуемое устройство ввода/вывода",
        showAdditionalSettings: "Показать Дополнительные Настройки", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Скрыть Дополнительные Настройки", // NEW TRANSLATION KEY
        askShareExportedFile: "Файл успешно экспортирован. Хотите поделиться им сейчас?",
        maxIzulatorWarning: "МАКС. КОЛ-ВО ИЗОЛИРУЮЩИХ УСТРОЙСТВ: 100!",
    },
    Deutsch: {
        title: "Schleifenrechner", loop: "Schleife", totalDevices: "Geräte in Schleife:", consumption: "Stromverbrauch:",
        crossSection: "Kabelquerschnitt:", cableLength: "Kabellänge:", batteryCapacity: "Batteriekapazität:",
        additionalConsumption: "Zusätzlicher Verbrauch von Sirenen:", workHours: "Betriebsstunden:",
        save: "Speichern", load: "Laden", new: "Neu", print: "PDF drucken", excel: "Excel exportieren",
        infoTooltip: "Maximal 250 Geräte pro Schleife. Maximaler Stromverbrauch 700 mA.",
        pdfDevice: "Gerät", pdfQuantity: "Anzahl", pdfCurrent: "Strom (mA)",
        pdfReportTitle: "Schleifenbericht",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Batteriekapazität:",
        pdfAdditionalConsumption: "Zusätzlicher Verbrauch von Sirenen:",
        pdfWorkHours: "Betriebsstunden:",
        excelExportTime: "Exportdatum:",
        excelPanelType: "Paneltyp:",
        excelLoopNumber: "Schleifennummer:",
        excelDeviceName: "Gerätename",
        excelQuantity: "Anzahl",
        excelConsumption: "Verbrauch (mA)",
        excelTotalDevicesLoop: "Geräte in Schleife:",
        excelTotalConsumptionLoop: "Stromverbrauch (Schleife):",
        excelLineResistance: "Leitungswiderstand:",
        excelCableResistance: "Kabelwiderstand:",
        excelCableLength: "Kabellänge (berechnet):",
        excelInputLength: "Eingegebene Kabellänge:",
        excelSelectedCross: "Kabelquerschnitt:",
        excelRequiredCross: "Erforderlicher Querschnitt:",
        excelBatteryCalcTitle: "--- Batterieberechnung ---",
        excelSelectedBattery: "Batteriekapazität:",
        excelTotalIdleCons: "Grundlast (gesamt):",
        excelTotalActiveCons: "Alarmlast (gesamt):",
        excelPassiveLife: "Batterielaufzeit:",
        inputCrossSectionTitle: "Kabelquerschnitt:",
        inputCableLengthTitle: "Kabellänge:",
        batteryAutonomyTitle: "Batterielaufzeit:",
        optSmokeDetector: "Adressierbarer Rauchmelder",
        heatDetector: "Adressierbarer Hitzemelder",
        optSmokeHeatDetector: "Adressierbarer Kombimelder",
        manualCallPoint: "Adressierbarer Handmelder",
        siren: "Adressierbare Sirene",
        module: "Adressierbares Modul",
        inOutDevice: "Adressierbares E/A-Modul",
        showAdditionalSettings: "Zusätzliche Einstellungen anzeigen", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Zusätzliche Einstellungen ausblenden", // NEW TRANSLATION KEY
        askShareExportedFile: "Datei erfolgreich exportiert. Möchten Sie sie jetzt teilen?",
        maxIzulatorWarning: "MAX. ANZAHL VON ISOLATORGERÄTEN IST 100!",
    },
    Español: {
        title: "Calculadora de bucle", loop: "Bucle", totalDevices: "Dispositivos en bucle:", consumption: "Consumo total:",
        crossSection: "Sección cable:", cableLength: "Longitud cable:", batteryCapacity: "Capacidad baterías:",
        additionalConsumption: "Consumo adicional:", workHours: "Horas trabajo:",
        save: "Guardar", load: "Cargar", new: "Nuevo", print: "PDF", excel: "Excel",
        infoTooltip: "Máximo 250 dispositivos. Consumo máximo 700 mA.",
        pdfDevice: "Dispositivo", pdfQuantity: "Cantidad", pdfCurrent: "Corriente (mA)",
        pdfReportTitle: "Informe de bucle",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Capacidad baterías:",
        pdfAdditionalConsumption: "Consumo adicional:",
        pdfWorkHours: "Horas trabajo:",
        excelExportTime: "Fecha exportación:",
        excelPanelType: "Tipo panel:",
        excelLoopNumber: "Número bucle:",
        excelDeviceName: "Dispositivo",
        excelQuantity: "Cantidad",
        excelConsumption: "Consumo (mA)",
        excelTotalDevicesLoop: "Dispositivos (bucle):",
        excelTotalConsumptionLoop: "Consumo (bucle):",
        excelLineResistance: "Resistencia línea:",
        excelCableResistance: "Resistencia cable:",
        excelCableLength: "Longitud cable:",
        excelInputLength: "Longitud introducida:",
        excelSelectedCross: "Sección seleccionada:",
        excelRequiredCross: "Sección requerida:",
        excelBatteryCalcTitle: "--- Cálculo baterías ---",
        excelSelectedBattery: "Capacidad baterías:",
        excelTotalIdleCons: "Consumo en reposo:",
        excelTotalActiveCons: "Consumo en alarma:",
        excelPassiveLife: "Autonomía estimada:",
        inputCrossSectionTitle: "Sección cable:",
        inputCableLengthTitle: "Longitud cable:",
        batteryAutonomyTitle: "Autonomía baterías:",
        optSmokeDetector: "Detector de humo direccionable",
        heatDetector: "Detector de calor direccionable",
        optSmokeHeatDetector: "Detector combinado direccionable",
        manualCallPoint: "Pulsador direccionable",
        siren: "Sirena direccionable",
        module: "Módulo direccionable",
        inOutDevice: "Módulo E/S direccionable",
        showAdditionalSettings: "Mostrar Ajustes Adicionales", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Ocultar Ajustes Adicionales", // NEW TRANSLATION KEY
        askShareExportedFile: "Archivo exportado con éxito. ¿Desea compartirlo ahora?",
        maxIzulatorWarning: "¡NÚM. MÁX. DE DISPOSITIVOS AISLADORES ES 100!",
    },
    Italiano: {
        title: "Calcolatore anello", loop: "Anello", totalDevices: "Dispositivi totali:", consumption: "Consumo totale:",
        crossSection: "Sezione cavo:", cableLength: "Lunghezza cavo:", batteryCapacity: "Capacità batterie:",
        additionalConsumption: "Consumo aggiuntivo:", workHours: "Ore lavoro:",
        save: "Salva", load: "Carica", new: "Nuovo", print: "PDF", excel: "Excel",
        infoTooltip: "Massimo 250 dispositivi. Consumo massimo 700 mA.",
        pdfDevice: "Dispositivo", pdfQuantity: "Quantità", pdfCurrent: "Corrente (mA)",
        pdfReportTitle: "Report dispositivi anello",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Capacità batterie:",
        pdfAdditionalConsumption: "Consumo aggiuntivo:",
        pdfWorkHours: "Ore lavoro:",
        excelExportTime: "Data esportazione:",
        excelPanelType: "Tipo pannello:",
        excelLoopNumber: "Numero anello:",
        excelDeviceName: "Dispositivo",
        excelQuantity: "Quantità",
        excelConsumption: "Consumo (mA)",
        excelTotalDevicesLoop: "Dispositivi (anello):",
        excelTotalConsumptionLoop: "Consumo (anello):",
        excelLineResistance: "Resistenza linea:",
        excelCableResistance: "Resistenza cavo:",
        excelCableLength: "Lunghezza cavo:",
        excelInputLength: "Lunghezza inserita:",
        excelSelectedCross: "Sezione selezionata:",
        excelRequiredCross: "Sezione richiesta:",
        excelBatteryCalcTitle: "--- Calcolo batterie ---",
        excelSelectedBattery: "Capacità batterie:",
        excelTotalIdleCons: "Consumo standby:",
        excelTotalActiveCons: "Consumo allarme:",
        excelPassiveLife: "Autonomia stimata:",
        inputCrossSectionTitle: "Sezione cavo:",
        inputCableLengthTitle: "Lunghezza cavo:",
        batteryAutonomyTitle: "Autonomia batterie:",
        optSmokeDetector: "Rilevatore fumo indirizzabile",
        heatDetector: "Rilevatore calore indirizzabile",
        optSmokeHeatDetector: "Rilevatore combinato indirizzabile",
        manualCallPoint: "Pulsante manuale indirizzabile",
        siren: "Sirena indirizzabile",
        module: "Modulo indirizzabile",
        inOutDevice: "Modulo I/O indirizzabile",
        showAdditionalSettings: "Mostra Impostazioni Aggiuntive", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Nascondi Impostazioni Aggiuntive", // NEW TRANSLATION KEY
        askShareExportedFile: "File esportato con successo. Vuoi condividerlo adesso?",
        maxIzulatorWarning: "N. MAX. DI DISPOSITIVI ISOLATORI È 100!",
    },
    Ελληνικά: {
        title: "Αριθμομηχανή Βρόχου", loop: "Βρόχος", totalDevices: "Συσκευές σε βρόχο:", consumption: "Συνολική κατανάλωση:",
        crossSection: "Διατομή:", cableLength: "Μήκος καλωδίου:", batteryCapacity: "Χωρητικότητα μπαταριών:",
        additionalConsumption: "Πρόσθετη κατανάλωση:", workHours: "Ώρες λειτουργίας:",
        save: "Αποθήκευση", load: "Φόρτωση", new: "Νέο", print: "Εκτύπωση PDF", excel: "Εξαγωγή Excel",
        infoTooltip: "Μέγιστο 250 συσκευές. Μέγιστη κατανάλωση 700 mA.",
        pdfDevice: "Συσκευή", pdfQuantity: "Ποσότητα", pdfCurrent: "Ρεύμα (mA)",
        pdfReportTitle: "Αναφορά Βρόχου",
        pdfCableLengthM: "m",
        pdfCrossSectionMM: "mm2",
        pdfBatteryCapacity: "Χωρητικότητα μπαταριών:",
        pdfAdditionalConsumption: "Πρόσθετη κατανάλωση:",
        pdfWorkHours: "Ώρες λειτουργίας:",
        excelExportTime: "Ημερομηνία εξαγωγής:",
        excelPanelType: "Τύπος πίνακα:",
        excelLoopNumber: "Αριθμός βρόχου:",
        excelDeviceName: "Συσκευή",
        excelQuantity: "Ποσότητα",
        excelConsumption: "Κατανάλωση (mA)",
        excelTotalDevicesLoop: "Συσκευές (βρόχος):",
        excelTotalConsumptionLoop: "Κατανάλωση (βρόχος):",
        excelLineResistance: "Αντίσταση γραμμής:",
        excelCableResistance: "Αντίσταση καλωδίου:",
        excelCableLength: "Μήκος καλωδίου:",
        excelInputLength: "Εισαγόμενο μήκος:",
        excelSelectedCross: "Επιλεγμένη διατομή:",
        excelRequiredCross: "Απαιτούμενη διατομή:",
        excelBatteryCalcTitle: "--- Υπολογισμός μπαταριών ---",
        excelSelectedBattery: "Χωρητικότητα μπαταριών:",
        excelTotalIdleCons: "Κατανάλωση στάσης:",
        excelTotalActiveCons: "Κατανάλωση συναγερμού:",
        excelPassiveLife: "Εκτιμώμενη αυτονομία:",
        inputCrossSectionTitle: "Διατομή καλωδίου:",
        inputCableLengthTitle: "Μήκος καλωδίου:",
        batteryAutonomyTitle: "Αυτονομία μπαταριών:",
        optSmokeDetector: "Διευθυνσιοδοτούμενος ανιχνευτής καπνού",
        heatDetector: "Διευθυνσιοδοτούμενος ανιχνευτής θερμότητας",
        optSmokeHeatDetector: "Διευθυνσιοδοτούμενος συνδυασμένος ανιχνευτής",
        manualCallPoint: "Διευθυνσιοδοτούμενος χειροκίνητος σταθμός",
        siren: "Διευθυνσιοδοτούμενη σειρήνα",
        module: "Διευθυνσιοδοτούμενη μονάδα",
        inOutDevice: "Διευθυνσιοδοτούμενη μονάδα Ε/Σ",
        showAdditionalSettings: "Εμφάνιση Πρόσθετων Ρυθμίσεων", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Απόκρυψη Πρόσθετων Ρυθμίσεων", // NEW TRANSLATION KEY
        askShareExportedFile: "Το αρχείο εξήχθη με επιτυχία. Θέλετε να το μοιραστείτε τώρα;",  
        maxIzulatorWarning: "ΜΕΓ. ΑΡΙΘΜΟΣ ΣΥΣΚΕΥΩΝ ΑΠΟΜΟΝΩΣΗΣ ΕΙΝΑΙ 100!",
    },
    Українська: {
        title: "Калькулятор петлі", loop: "Петля", totalDevices: "Пристроїв у петлі:", consumption: "Споживання:",
        crossSection: "Переріз:", cableLength: "Довжина кабелю:", batteryCapacity: "Ємність акумуляторів:",
        additionalConsumption: "Додаткове споживання:", workHours: "Години роботи:",
        save: "Зберегти", load: "Завантажити", new: "Новий", print: "Друк PDF", excel: "Експорт Excel",
        infoTooltip: "Максимум 250 пристроїв. Максимальне споживання 700 мА.",
        pdfDevice: "Пристрій", pdfQuantity: "Кількість", pdfCurrent: "Струм (мА)",
        pdfReportTitle: "Звіт петлі",
        pdfCableLengthM: "м",
        pdfCrossSectionMM: "мм2",
        pdfBatteryCapacity: "Ємність акумуляторів:",
        pdfAdditionalConsumption: "Додаткове споживання:",
        pdfWorkHours: "Години роботи:",
        excelExportTime: "Дата експорту:",
        excelPanelType: "Тип панелі:",
        excelLoopNumber: "Номер петлі:",
        excelDeviceName: "Пристрій",
        excelQuantity: "Кількість",
        excelConsumption: "Споживання (мА)",
        excelTotalDevicesLoop: "Пристроїв (петля):",
        excelTotalConsumptionLoop: "Споживання (петля):",
        excelLineResistance: "Опір лінії:",
        excelCableResistance: "Опір кабелю:",
        excelCableLength: "Довжина кабелю:",
        excelInputLength: "Введена довжина:",
        excelSelectedCross: "Обраний переріз:",
        excelRequiredCross: "Необхідний переріз:",
        excelBatteryCalcTitle: "--- Розрахунок акумуляторів ---",
        excelSelectedBattery: "Ємність акумуляторів:",
        excelTotalIdleCons: "Споживання очікування:",
        excelTotalActiveCons: "Споживання тривоги:",
        excelPassiveLife: "Очікувана автономія:",
        inputCrossSectionTitle: "Переріз кабелю:",
        inputCableLengthTitle: "Довжина кабелю:",
        batteryAutonomyTitle: "Автономія акумуляторів:",
        optSmokeDetector: "Адресний оптичний датчик диму",
        heatDetector: "Адресний тепловий датчик",
        optSmokeHeatDetector: "Адресний комбінований датчик",
        manualCallPoint: "Адресна ручна станція",
        siren: "Адресна сирена",
        module: "Адресний модуль",
        inOutDevice: "Адресний модуль В/В",
        showAdditionalSettings: "Показати Додаткові Налаштування", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Приховати Додаткові Налаштування", // NEW TRANSLATION KEY
        askShareExportedFile: "Файл успішно експортовано. Бажаєте поділитися ним зараз?",
        maxIzulatorWarning: "МАКС. КІЛЬКІСТЬ ІЗОЛЮВАЛЬНИХ ПРИСТРОЇВ — 100!",
    },
    עברית: {
        title: "מחשבון לולאה", loop: "לולאה", totalDevices: "מכשירים בלולאה:", consumption: "צריכת זרם:",
        crossSection: "חתך כבל:", cableLength: "אורך כבל:", batteryCapacity: "קיבול סוללות:",
        additionalConsumption: "צריכה נוספת:", workHours: "שעות עבודה:",
        save: "שמור", load: "טען", new: "חדש", print: "הדפס PDF", excel: "ייצא Excel",
        infoTooltip: "מקסימום 250 מכשירים. צריכה מקסימלית 700 mA.",
        pdfDevice: "מכשיר", pdfQuantity: "כמות", pdfCurrent: "זרם (mA)",
        pdfReportTitle: "דוח לולאה",
        pdfCableLengthM: "מ'",
        pdfCrossSectionMM: "מ\"ר",
        pdfBatteryCapacity: "קיבול סוללות:",
        pdfAdditionalConsumption: "צריכה נוספת:",
        pdfWorkHours: "שעות עבודה:",
        excelExportTime: "תאריך יצוא:",
        excelPanelType: "סוג לוח:",
        excelLoopNumber: "מספר לולאה:",
        excelDeviceName: "מכשיר",
        excelQuantity: "כמות",
        excelConsumption: "צריכה (mA)",
        excelTotalDevicesLoop: "מכשירים (לולאה):",
        excelTotalConsumptionLoop: "צריכה (לולאה):",
        excelLineResistance: "התנגדות קו:",
        excelCableResistance: "התנגדות כבל:",
        excelCableLength: "אורך כבל:",
        excelInputLength: "אורך שהוזן:",
        excelSelectedCross: "חתך נבחר:",
        excelRequiredCross: "חתך נדרש:",
        excelBatteryCalcTitle: "--- חישוב סוללות ---",
        excelSelectedBattery: "קיבול סוללות:",
        excelTotalIdleCons: "צריכה במצב המתנה:",
        excelTotalActiveCons: "צריכה במצב אזעקה:",
        excelPassiveLife: "אוטונומיה משוערת:",
        inputCrossSectionTitle: "חתך כבל:",
        inputCableLengthTitle: "אורך כבל:",
        batteryAutonomyTitle: "אוטונומית סוללות:",
        optSmokeDetector: "גלאי עשן כתובתי",
        heatDetector: "גלאי חום כתובתי",
        optSmokeHeatDetector: "גלאי משולב כתובתי",
        manualCallPoint: "לחצן ידני כתובתי",
        siren: "צופר כתובתי",
        module: "מודול כתובתי",
        inOutDevice: "מודול קלט/פלט כתובתי",
        showAdditionalSettings: "הצג הגדרות נוספות", // NEW TRANSLATION KEY
        hideAdditionalSettings: "הסתר הגדרות נוספות", // NEW TRANSLATION KEY
        askShareExportedFile: "הקובץ ייצא בהצלחה. האם ברצונך לשתפו עכשיו?",
        maxIzulatorWarning: ".!100 הוּא מַבְדְּדִים מִסְפַּר מַקְסִימָלִי",
    },
    中文: {
        title: "回路计算器", loop: "回路", totalDevices: "回路设备总数:", consumption: "总耗电量:",
        crossSection: "电缆截面:", cableLength: "电缆长度:", batteryCapacity: "电池容量:",
        additionalConsumption: "附加耗电量:", workHours: "工作时间:",
        save: "保存", load: "加载", new: "新建", print: "打印PDF", excel: "导出Excel",
        infoTooltip: "设备总数不超过250个。总耗电量不超过700 mA。",
        pdfDevice: "设备", pdfQuantity: "数量", pdfCurrent: "电流(mA)",
        pdfReportTitle: "回路设备报告",
        pdfCableLengthM: "米",
        pdfCrossSectionMM: "平方毫米",
        pdfBatteryCapacity: "电池容量:",
        pdfAdditionalConsumption: "附加耗电量:",
        pdfWorkHours: "工作时间:",
        excelExportTime: "导出时间:",
        excelPanelType: "面板类型:",
        excelLoopNumber: "回路编号:",
        excelDeviceName: "设备名称",
        excelQuantity: "数量",
        excelConsumption: "耗电量(mA)",
        excelTotalDevicesLoop: "设备总数(回路):",
        excelTotalConsumptionLoop: "总耗电量(回路):",
        excelLineResistance: "线路电阻:",
        excelCableResistance: "电缆电阻:",
        excelCableLength: "电缆长度:",
        excelInputLength: "输入长度:",
        excelSelectedCross: "选择截面:",
        excelRequiredCross: "所需截面:",
        excelBatteryCalcTitle: "--- 电池计算 ---",
        excelSelectedBattery: "电池容量:",
        excelTotalIdleCons: "待机耗电:",
        excelTotalActiveCons: "报警耗电:",
        excelPassiveLife: "预计续航:",
        inputCrossSectionTitle: "电缆截面:",
        inputCableLengthTitle: "电缆长度:",
        batteryAutonomyTitle: "电池续航:",
        optSmokeDetector: "可寻址光电烟感",
        heatDetector: "可寻址热感",
        optSmokeHeatDetector: "可寻址复合探测器",
        manualCallPoint: "可寻址手动报警按钮",
        siren: "可寻址警号",
        module: "可寻址模块",
        inOutDevice: "可寻址输入输出模块",
        showAdditionalSettings: "显示附加设置", // NEW TRANSLATION KEY
        hideAdditionalSettings: "隐藏附加设置", // NEW TRANSLATION KEY
        askShareExportedFile: "文件已成功导出。您现在想要分享它吗？",
        maxIzulatorWarning: "隔离设备最大数量为100！",
    },
    العربية: {
        title: "حاسبة الحلقة", loop: "حلقة", totalDevices: "إجمالي الأجهزة:", consumption: "إجمالي الاستهلاك:",
        crossSection: "مقطع الكابل:", cableLength: "طول الكابل:", batteryCapacity: "سعة البطاريات:",
        additionalConsumption: "استهلاك إضافي:", workHours: "ساعات العمل:",
        save: "حفظ", load: "تحميل", new: "جديد", print: "طباعة PDF", excel: "تصدير Excel",
        infoTooltip: "لا يتجاوز إجمالي الأجهزة 250. لا يتجاوز إجمالي الاستهلاك 700 مللي أمبير.",
        pdfDevice: "الجهاز", pdfQuantity: "الكمية", pdfCurrent: "التيار (مللي أمبير)",
        pdfReportTitle: "تقرير أجهزة الحلقة",
        pdfCableLengthM: "م",
        pdfCrossSectionMM: "مم2",
        pdfBatteryCapacity: "سعة البطاريات:",
        pdfAdditionalConsumption: "استهلاك إضافي:",
        pdfWorkHours: "ساعات العمل:",
        excelExportTime: "وقت التصدير:",
        excelPanelType: "نوع اللوحة:",
        excelLoopNumber: "رقم الحلقة:",
        excelDeviceName: "اسم الجهاز",
        excelQuantity: "الكمية",
        excelConsumption: "الاستهلاك (مللي أمبير)",
        excelTotalDevicesLoop: "إجمالي الأجهزة (الحلقة):",
        excelTotalConsumptionLoop: "إجمالي الاستهلاك (الحلقة):",
        excelLineResistance: "مقاومة الخط:",
        excelCableResistance: "مقاومة الكابل:",
        excelCableLength: "طول الكابل:",
        excelInputLength: "طول الإدخال:",
        excelSelectedCross: "المقطع المحدد:",
        excelRequiredCross: "المقطع المطلوب:",
        excelBatteryCalcTitle: "--- حساب البطارية ---",
        excelSelectedBattery: "سعة البطاريات:",
        excelTotalIdleCons: "استهلاك الخمول:",
        excelTotalActiveCons: "استهلاك التنبيه:",
        excelPassiveLife: "العمر المتوقع:",
        inputCrossSectionTitle: "مقطع الكابل:",
        inputCableLengthTitle: "طول الكابل:",
        batteryAutonomyTitle: "عمر البطارية:",
        optSmokeDetector: "كاشف دخان عنواني",
        heatDetector: "كاشف حرارة عنواني",
        optSmokeHeatDetector: "كاشف دخان وحرارة عنواني",
        manualCallPoint: "زر نداء يدوي عنواني",
        siren: "صفارة عنوانية",
        module: "وحدة عنوانية",
        inOutDevice: "وحدة إدخال/إخراج عنوانية",
        showAdditionalSettings: "إظهار الإعدادات الإضافية", // NEW TRANSLATION KEY
        hideAdditionalSettings: "إخفاء الإعدادات الإضافية", // NEW TRANSLATION KEY
        askShareExportedFile: "تم تصدير الملف بنجاح. هل تريد مشاركته الآن؟",
        maxIzulatorWarning: ".!100 الحد الأقصى لعدد أجهزة العزل هو",
    },
    Македонски: {
        title: "Калкулатор за јамки", loop: "Јамка", totalDevices: "Вкупно уреди:", consumption: "Вкупна потрошувачка:",
        crossSection: "Пресек:", cableLength: "Должина на кабел:", batteryCapacity: "Капацитет на батерии:",
        additionalConsumption: "Дополнителна потрошувачка:", workHours: "Работни часови:",
        save: "Зачувај", load: "Вчитај", new: "Ново", print: "Печати PDF", excel: "Извези Excel",
        infoTooltip: "Вкупно уреди не смеат да надминуваат 250. Вкупна потрошувачка не смее да надминува 700 mA.",
        pdfDevice: "Уред", pdfQuantity: "Количина", pdfCurrent: "Струја (mA)",
        pdfReportTitle: "Извештај за јамка",
        pdfCableLengthM: "м",
        pdfCrossSectionMM: "мм2",
        pdfBatteryCapacity: "Капацитет на батерии:",
        pdfAdditionalConsumption: "Дополнителна потрошувачка:",
        pdfWorkHours: "Работни часови:",
        excelExportTime: "Време на извоз:",
        excelPanelType: "Тип на панел:",
        excelLoopNumber: "Број на јамка:",
        excelDeviceName: "Уред",
        excelQuantity: "Количина",
        excelConsumption: "Потрошувачка (mA)",
        excelTotalDevicesLoop: "Вкупно уреди (Јамка):",
        excelTotalConsumptionLoop: "Вкупна потрошувачка (Јамка):",
        excelLineResistance: "Отпор на линија:",
        excelCableResistance: "Отпор на кабел:",
        excelCableLength: "Должина на кабел:",
        excelInputLength: "Внесена должина:",
        excelSelectedCross: "Избран пресек:",
        excelRequiredCross: "Потребен пресек:",
        excelBatteryCalcTitle: "--- Пресметка на батерии ---",
        excelSelectedBattery: "Капацитет на батерии:",
        excelTotalIdleCons: "Потрошувачка во мирување:",
        excelTotalActiveCons: "Активна потрошувачка:",
        excelPassiveLife: "Проценет живот:",
        inputCrossSectionTitle: "Пресек на кабел:",
        inputCableLengthTitle: "Должина на кабел:",
        batteryAutonomyTitle: "Автономија на батерии:",
        optSmokeDetector: "Адресибилен оптички детектор за дим",
        heatDetector: "Адресибилен топлински детектор",
        optSmokeHeatDetector: "Адресибилен комбиниран детектор",
        manualCallPoint: "Адресибилен рачен аларм",
        siren: "Адресибилна сирена",
        module: "Адресибилен модул",
        inOutDevice: "Адресибилен влезно/излезен модул",
        showAdditionalSettings: "Прикажи Дополнителни Поставки", // NEW TRANSLATION KEY
        hideAdditionalSettings: "Скриј Дополнителни Поставки", // NEW TRANSLATION KEY
        askShareExportedFile: "Датотеката е успешно извезена. Дали сакате сега да ја споделите?",
        maxIzulatorWarning: "МАКС. БРОЈ НА ИЗОЛАТОРСКИ УРЕДИ Е 100!",
    }
};
export default translations;